// src/components/WorkspaceSwitcher.tsx
import styled from "styled-components";
import { Workspace } from "../services/workspaceApi";

type Props = {
  workspaces: Workspace[];
  active: Workspace | null;
  onSwitch: (workspaceId: string) => void;
  fullWidth?: boolean;
};

const label = (workspace: Workspace) =>
  `${workspace.name} · ${workspace.isOwn ? "Owner" : "Employee"}`;

/** Business switcher; renders nothing unless there are two or more. */
const WorkspaceSwitcher = ({ workspaces, active, onSwitch, fullWidth }: Props) => {
  if (workspaces.length < 2) return null;
  return (
    <Select
      aria-label="Switch business"
      value={active?.id ?? ""}
      $fullWidth={fullWidth}
      onChange={(e) => onSwitch(e.target.value)}
    >
      {!active && (
        <option value="" disabled>
          Choose business
        </option>
      )}
      {workspaces.map((workspace) => (
        <option key={workspace.id} value={workspace.id}>
          {label(workspace)}
        </option>
      ))}
    </Select>
  );
};

export default WorkspaceSwitcher;

const Select = styled.select<{ $fullWidth?: boolean }>`
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
  max-width: ${({ $fullWidth }) => ($fullWidth ? "none" : "240px")};
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #111827;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  text-overflow: ellipsis;

  &:focus {
    outline: 2px solid #2563eb;
    outline-offset: 1px;
  }
`;
